import {
  faBrain,
  faNotesMedical,
  faHeartbeat,
  faStethoscope,
  faChild,
  faChalkboardTeacher,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useMemo, useState } from 'react'

import useAxiosPrivate from '../hooks/useAxiosPrivate'

function ServicesGrid({ onViewService }) {
  const axiosPrivate = useAxiosPrivate()
  const [services, setServices] = useState([])
  const [loading, setLoading] = useState(true)

  const uiByName = useMemo(
    () => ({
      'Mental Health': {
        colour: 'border-[#FDD2B7]',
        iconColour: 'bg-[#FDD2B7]',
        textColour: 'text-[#FDD2B7]',
        icon: faBrain,
      },
      'Health Line': {
        colour: 'border-[#E7CDDB]',
        iconColour: 'bg-[#E7CDDB]',
        textColour: 'text-[#E7CDDB]',
        icon: faNotesMedical,
      },
      'Physical Health': {
        colour: 'border-[#9FB8BE]',
        iconColour: 'bg-[#9FB8BE]',
        textColour: 'text-[#9FB8BE]',
        icon: faHeartbeat,
      },
      'General Health & Wellbeing': {
        colour: 'border-[#C1CCE5]',
        iconColour: 'bg-[#C1CCE5]',
        textColour: 'text-[#C1CCE5]',
        icon: faStethoscope,
      },
      'Happier Healthier You': {
        colour: 'border-[#B7DFBC]',
        iconColour: 'bg-[#B7DFBC]',
        textColour: 'text-[#B7DFBC]',
        icon: faChalkboardTeacher,
      },
      // 'Pupil Wellbeing': {
      //   colour: 'border-[#F9B6CA]',
      //   iconColour: 'bg-[#F9B6CA]',
      //   textColour: 'text-[#F9B6CA]',
      //   icon: faChild,
      // },
    }),
    []
  )

  useEffect(() => {
    let cancelled = false
    setLoading(true)

    axiosPrivate
      .get('/service-catalog')
      .then((response) => {
        if (cancelled) return
        const apiServices = response?.data?.result?.services
        if (!Array.isArray(apiServices)) {
          setServices([])
          return
        }

        setServices(
          apiServices.map((service) => {
            const ui = uiByName?.[service?.name] || {}
            return {
              ...service,
              ...ui,
              products: Array.isArray(service?.products) ? service.products : [],
            }
          })
        )
      })
      .catch(() => {
        if (cancelled) return
        setServices([])
      })
      .finally(() => {
        if (cancelled) return
        setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [axiosPrivate, uiByName])

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {loading && (
        <div className="col-span-full text-sm text-[#41264B] opacity-70">
          Loading services…
        </div>
      )}
      {services.map((service, index) => (
        <div
          key={index}
          className={`bg-white rounded-xl p-4 shadow-md border-l-8 ${service.colour} hover:shadow-lg transition`}
        >
          <div className="flex items-center gap-3 mb-2">
            <div className={`rounded-lg px-3.5 py-2 ${service.iconColour}`}>
              <FontAwesomeIcon icon={service.icon} className="text-[#41264B]" />
            </div>
            <h3 className="text-[#41264B] font-semibold text-lg">
              {service.name}
            </h3>
          </div>
          <p className="text-sm text-[#41264B] mb-4">{service.description}</p>
          {service.products.length > 0 && (<button
            onClick={() => {
              onViewService(service)
            }}
            className="w-full border border-[#B4A6BA] text-[#866393] rounded-lg py-1 hover:bg-violet-50 transition text-sm"
          >
            View Services
          </button> )}
        </div>
      ))}
    </div>
  )
}

export default ServicesGrid
